/* Banner de cookies (Susmies)
   Usa la Customer Privacy API de Shopify para registrar el consentimiento de
   forma compatible con GDPR. Solo se muestra cuando Shopify indica que hace
   falta (región regulada y sin decisión previa). */
(function () {
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  var STORAGE_KEY = 'iurop_cookie_consent_v1';

  function $(sel) {
    return banner.querySelector(sel);
  }

  function show() {
    banner.classList.add('is-visible');
    banner.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    banner.classList.remove('is-visible');
    banner.classList.remove('is-prefs-open');
    banner.setAttribute('aria-hidden', 'true');
  }

  function togglePrefs(open) {
    banner.classList.toggle('is-prefs-open', open);
  }

  function applyConsent(consent) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') {
        cp.setTrackingConsent(consent, function () { hide(); });
      } else {
        hide();
      }
    } catch (e) {
      hide();
    }
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function acceptAll() {
    applyConsent({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
  }

  function declineAll() {
    applyConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
  }

  function savePrefs() {
    var analytics = $('[data-cookie-pref="analytics"]');
    var marketing = $('[data-cookie-pref="marketing"]');
    var prefs = $('[data-cookie-pref="preferences"]');
    applyConsent({
      analytics: analytics ? analytics.checked : false,
      marketing: marketing ? marketing.checked : false,
      preferences: prefs ? prefs.checked : false,
      sale_of_data: marketing ? marketing.checked : false
    });
  }

  // --- Eventos ---
  banner.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cookie-action]');
    if (!el) return;
    var action = el.getAttribute('data-cookie-action');
    if (action === 'accept') acceptAll();
    else if (action === 'decline') declineAll();
    else if (action === 'manage') togglePrefs(!banner.classList.contains('is-prefs-open'));
    else if (action === 'save') savePrefs();
  });

  // Permite reabrir el banner desde un enlace del footer:
  // <a data-cookie-settings-trigger>Cookies</a>
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cookie-settings-trigger]');
    if (!trigger) return;
    e.preventDefault();
    show();
    togglePrefs(true);
  });

  // API pública por si se quiere abrir desde otro script.
  window.iuropCookieBanner = { open: show, close: hide };

  function decide() {
    // Cierre definitivo: si ya hubo una decisión en este dispositivo, no volver
    // a mostrar el banner NUNCA, aunque la API de consentimiento de Shopify
    // tarde en propagar la cookie entre páginas (era lo que hacía que el banner
    // reapareciera en cada cambio de página).
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) {}
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.shouldShowBanner === 'function') {
        if (cp.shouldShowBanner()) show();
        return;
      }
    } catch (e) {}
    // Fallback si la API no está disponible (p. ej. previsualización).
    show();
  }

  function init() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { decide(); }
      );
    } else {
      decide();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
